import styled from "styled-components";
import { smMedia } from "../../../utils/getMediaStyle";

export const Section = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
`;

export const BodyPadding = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 5%;
`;

export const Col = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: ${(props) => (props.width ? props.width : 50)}%;
  min-width: 300px;
`;

export const Image = styled.img`
  max-width: 100%;
  width: 500px;
  height: auto;
  padding-top: 1%;
  padding-left: 2%;
  padding-right: 2%;
  align-self: center;
  ${smMedia`
    width: 189px;
  `}
  clip-path: circle(45% at center);
`;

export const ContentBlock = styled.div`
  padding-top: 116px;
  padding-bottom: 102px;
  ${smMedia`
    padding-top: 58px;
    padding-bottom: 48px;
  `}
`;

export const Logo = styled.img`
  width: 40px;
  height: 40px;
  align-self: center;
`;
